export const PageSizeCalculate = (numberOfRecords, pagination) => {
  return Number.isInteger(numberOfRecords / pagination?.pageSize)
    ? numberOfRecords / pagination?.pageSize
    : parseInt(numberOfRecords / pagination?.pageSize) + 1;
};

// export const totalPrice = (arr) => {
//   let sum = 0;
//   arr?.forEach((item) => {
//     sum += (item?.unitPrice * item?.quantity)
//   })
//   return sum?.toFixed(2);
// }
export const totalPrice = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return 0;

  let sum = 0;

  arr.forEach((item) => {
    const total = parseFloat(item?.total || 0);
    if (!isNaN(total)) {
      sum += total;
    }
  });

  return sum.toFixed(2); 
};

export const totalPriceInventory = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return 0;

  let sum = 0;

  arr.forEach((item) => {
    const total = parseFloat(item?.amount || 0);
    if (!isNaN(total)) {
      sum += total;
    }
  });

  return sum.toFixed(2);
};